import { render, staticRenderFns } from "./RequestAppointmentAtJoinInvitePage.vue?vue&type=template&id=2491aad8&scoped=true"
import script from "./RequestAppointmentAtJoinInvitePage.vue?vue&type=script&lang=js"
export * from "./RequestAppointmentAtJoinInvitePage.vue?vue&type=script&lang=js"
import style0 from "./RequestAppointmentAtJoinInvitePage.vue?vue&type=style&index=0&id=2491aad8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2491aad8",
  null
  
)

export default component.exports